import { Box } from "@material-ui/core"
import type { ReactElement } from "react"

import "./image-viewer.styles.scss"
import { getPreviewImage } from "../../../utils"

export interface IIMageViewerProps {
  source: string
  alt: string
}

export function ImageViewer(props: IIMageViewerProps): ReactElement {
  const { source, alt } = props

  return (
    <Box className="image-viewer">
      <img src={getPreviewImage(source)} alt={alt} />
    </Box>
  )
}
